import { GET_ANALYTICS_FAILED, GET_ANALYTICS_REQUEST, GET_ANALYTICS_RESET, GET_ANALYTICS_SUCCESS, SET_DASHBOARD_REVIEW } from "../types"

export const getAnalyticsRequest = (data) => ({
	type: GET_ANALYTICS_REQUEST,
	payload: data,
})

export const getAnalyticsRequestSuccess = (data) => ({
	type: GET_ANALYTICS_SUCCESS,
	payload: data,
})

export const getAnalyticsRequestFailed = (data) => ({
	type: GET_ANALYTICS_FAILED,
	payload: data,
})

export const getAnalyticsRequestReset = () => ({
	type: GET_ANALYTICS_RESET,
})

export const setDashboardReview = (data) => ({
	type: SET_DASHBOARD_REVIEW,
	payload: data,
})
